// src/components/Layout.jsx
import React, { useEffect, useState } from 'react';
import Header from './HeaderComponents.jsx';
import SocialIcons from './Social-icons.jsx';
import Footer from './FooterComponents.jsx';

const Layout = ({ children, data }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(v => !v);

  const smoothScrollTo = (hash) => {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    if (!data) return;
    const anchors = Array.from(document.querySelectorAll('a[href^="#"]'));
    const onClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
      if (href && href.startsWith('#') && href.length > 1) {
        e.preventDefault();
        smoothScrollTo(href);
      }
    };
    anchors.forEach(a => a.addEventListener('click', onClick));
    return () => anchors.forEach(a => a.removeEventListener('click', onClick));
  }, [data]);

  return (
    <>
      <Header
        isScrolled={isScrolled}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        data={data}
        smoothScrollTo={smoothScrollTo}
      />
      <SocialIcons socialIcons={data?.socialIcons} />
      <main>{children}</main>
      <Footer data={data} />
    </>
  );
};

export default Layout;
